export default function Logo({ dark = false }) {
  return (
    <span className="flex items-baseline gap-1 select-none" data-testid="brand-logo">
      <span
        className="font-serif-display italic text-2xl leading-none tracking-tight"
        style={{ color: dark ? "#FAF9F6" : "#121212" }}
      >
        Max&nbsp;Dhum
      </span>
      <span className="inline-block w-2 h-2 rounded-full" style={{ background: "#C83E2B" }} />
    </span>
  );
}
